import { DownloadSharp } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const ExportButton = ({
    newItemsCount,
    notExportedItemsCount,
    onOpenExportModal,
}: {
    newItemsCount: number;
    notExportedItemsCount: number;
    onOpenExportModal: () => void;
}) => {
    return (
        <Button
            data-testid="exportButtonModal"
            fullWidth
            aria-controls="simple-menu"
            aria-haspopup="true"
            variant={notExportedItemsCount ? 'contained' : 'outlined'}
            size="small"
            onClick={onOpenExportModal}
            sx={{
                textTransform: 'capitalize',
                borderColor: !notExportedItemsCount
                    ? 'primary.light'
                    : 'inherit',
                color: !notExportedItemsCount ? 'primary.light' : 'inherit',
            }}
            startIcon={
                <DownloadSharp
                    sx={{
                        position: 'absolute',
                        left: 8,
                        top: 6,
                    }}
                />
            }
        >
            <FormattedMessage id="exportToTPS" />
            {notExportedItemsCount ? (
                <Typography
                    borderRadius={50}
                    lineHeight={1}
                    sx={{
                        position: 'absolute',
                        height: 18,
                        width: 18,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        right: 8,
                        top: 6,
                        fontSize: 13,
                        backgroundColor: 'rgba(0,0,0, 0.50)',
                    }}
                >
                    {notExportedItemsCount}
                </Typography>
            ) : (
                <></>
            )}
        </Button>
    );
};

export default ExportButton;
